/*
 * File: tags.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 23, 2025 at 9:29 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 24, 2025 at 12:31 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Constants
const { TAG_FAMILIES } = require('../../constants/base.constants');


/**
 * Utilities
 */

export const formatTagFamilies = (storyTags, translator, partnerId, limitToUsage = false) => {

	// Initialize tags
	let tags = storyTags || [];

	// Filter by usage if necessary
	if (limitToUsage) {
		tags = tags.filter((tag) => tag.usage_count[partnerId] > 0);
	}

	// Organize tags
	let tagFamilyArray = [];
	tags.forEach((tag) => {

		// Get family to compare
		let tagFamily = tag.family;
		const familyName = TAG_FAMILIES[tagFamily];
		if (familyName != null) {
			const family = TAG_FAMILIES[tagFamily];
			if (family.combineWith) tagFamily = family.combineWith;
		}

		// Check for existing tag family
		let exists = false;
		for (let i = 0; i < tagFamilyArray.length; i += 1) {
			if (tagFamilyArray[i].family === tagFamily) {
				exists = true;
				tagFamilyArray[i].tags.push(tag);
				break;
			}
		}

		// Create new tag family
		if (exists === false) {

			// Create family name
			if (familyName != null) {

				// Add tag family
				tagFamilyArray.push({
					family: tag.family,
					family_name: translator(`tagFamilies.${tagFamily}.title`),
					tags: [tag]
				});
			}
		}
	});

	// Filter tag families
	tagFamilyArray = tagFamilyArray.filter((family) => family.tags.length > 0);

	// Return tags
	return tagFamilyArray;
};
